import React from "react";
import "./OfflineBanner.css";

/**
 * Banner discreto que indica modo offline.
 * @param {Object} props
 * @param {Object|null} props.syncInfo - { timestamp, count } de la última sincronización
 */
export default function OfflineBanner({ syncInfo }) {
  const formatSyncDate = (timestamp) => {
    if (!timestamp) return "";
    return new Date(timestamp).toLocaleString("es-MX", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <div className="offline-banner">
      <i className="fa-solid fa-cloud-arrow-down"></i>
      <span>Sin conexión</span>
      {syncInfo?.timestamp && (
        <span className="offline-sync-info">
          — Sincronizado: {formatSyncDate(syncInfo.timestamp)}
        </span>
      )}
    </div>
  );
}
